/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgHexagon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M10.627 1.62a2.75 2.75 0 012.746 0h.002l7 4A2.75 2.75 0 0121.75 8v8a2.753 2.753 0 01-1.375 2.38l-.003.001-6.997 3.998-.002.002a2.75 2.75 0 01-2.748-.002l-6.997-3.998-.003-.002a2.75 2.75 0 01-1.375-2.378V8a2.753 2.753 0 011.375-2.38l.003-.001 6.999-4zM12 2.752c-.22 0-.435.058-.625.168l-.003.001L4.375 6.92h-.001A1.25 1.25 0 003.75 8v8a1.25 1.25 0 00.624 1.08h.001l7 4a1.25 1.25 0 001.25 0l.003-.001 6.997-3.998.001-.001A1.25 1.25 0 0020.25 16V8a1.25 1.25 0 00-.624-1.08h-.001l-7-4A1.25 1.25 0 0012 2.752z'
      />
    </svg>
  );
}

export default SvgHexagon;
